module.exports = __webpack_public_path__ + "icon-phone.svg?4151af7d6617ee6de20284d765bf7372";